import {
    type CarFilterIdType,
    StockCarFilterId,
    UsedCarFilterId,
    UscContext,
} from "../../shared-logic/types/UscCommonTypes";
import {
    type MinMaxSliderFilterIdType,
    type MultipleChoiceFilterIdType,
    type PriceFilterIdType,
    type StockCarMinMaxSliderFilterIdType,
    type StockCarMultipleChoiceFilterIdType,
    type UsedCarMinMaxSliderFilterIdType,
    type UsedCarMultipleChoiceFilterIdType,
    stockCarMinMaxSliderFilterIds,
    stockCarMultipleChoiceFilterIds,
    usedCarMinMaxSliderFilterIds,
    usedCarMultipleChoiceFilterIds,
} from "../../shared-logic/utils/filterConstants";

// Type guards and helpers for filter IDs.
export const isMinMaxSlider = (filterId: CarFilterIdType): filterId is MinMaxSliderFilterIdType =>
    usedCarMinMaxSliderFilterIds.includes(filterId as UsedCarMinMaxSliderFilterIdType) ||
    stockCarMinMaxSliderFilterIds.includes(filterId as StockCarMinMaxSliderFilterIdType);

export const isMultipleChoice = (filterId: CarFilterIdType): filterId is MultipleChoiceFilterIdType =>
    usedCarMultipleChoiceFilterIds.includes(filterId as UsedCarMultipleChoiceFilterIdType) ||
    stockCarMultipleChoiceFilterIds.includes(filterId as StockCarMultipleChoiceFilterIdType);

export const isPrice = (filterId: CarFilterIdType): filterId is PriceFilterIdType =>
    filterId === UsedCarFilterId.Price || filterId === StockCarFilterId.Price;

export const isDeliverable = (filterId: CarFilterIdType): filterId is UsedCarMultipleChoiceFilterIdType =>
    filterId === UsedCarFilterId.Deliverable;

export const getLocationFilterId = (
    currentContext: UscContext,
): UsedCarFilterId.Location | StockCarFilterId.Location =>
    currentContext === UscContext.Used ? UsedCarFilterId.Location : StockCarFilterId.Location;

export const isHiddenFilter = (filterId: CarFilterIdType): boolean => isDeliverable(filterId);

/**
 * Get an array containing all the filters based on the currentFilter prop.
 */
export const getCurrentFilters = (currentFilter: UscContext): CarFilterIdType[] => {
    switch (currentFilter) {
        case UscContext.Used:
            return Object.values(UsedCarFilterId);
        case UscContext.Stock:
            return Object.values(StockCarFilterId);
        default:
            return [];
    }
};
